// Backend calls for the "Komunikaty" (Notification template) module -
// mirrors exercise-templates/api.js's shape/conventions exactly.

import axios from 'axios';

const jsonHeaders = {
   withCredentials: true,
   headers: { 'Content-Type': 'application/json' },
};

export function getNotifications() {
   return axios.get('/api/notifications', { withCredentials: true });
}

export function getNotification(id) {
   return axios.get('/api/notifications/' + id, { withCredentials: true });
}

export function createNotification(payload) {
   return axios.post('/api/notifications', JSON.stringify(payload), jsonHeaders);
}

export function updateNotification(id, payload) {
   return axios.put('/api/notifications/' + id, JSON.stringify(payload), jsonHeaders);
}

export function deleteNotification(id) {
   return axios.delete('/api/notifications/' + id, jsonHeaders);
}

// --- StudentNotification (per-student assignment) ---

export function getStudentNotifications(studentId) {
   return axios.get('/api/student-notifications', { params: { student: studentId }, withCredentials: true });
}

export function assignNotification(studentId, notificationId) {
   return axios.post('/api/student-notifications', JSON.stringify({ student: studentId, notification: notificationId }), jsonHeaders);
}

export function unassignNotification(id) {
   return axios.delete('/api/student-notifications/' + id, jsonHeaders);
}
